import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import { CustomerProvider } from './lib/customer';
import { CurrencyProvider } from './lib/currency';
import { ProjectListProvider } from './lib/projectList';
import { App } from './App';
import { ProjectListPanel } from './components/ProjectListPanel';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { CookieBanner } from './components/CookieBanner';
import { AsesorAIChat } from './components/AsesorAIChat';
import { initGtag, initMetaPixel } from './lib/tracking';

// Inicializar Google Tag (Ads + Analytics) — no-op si VITE_GTAG_ID no está set
initGtag();
// Inicializar Meta Pixel (retargeting + optimización a conversión) — no-op si VITE_META_PIXEL_ID no está set
initMetaPixel();

// Register service worker for PWA (vendedora app + cache)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }).catch(() => {});
  });
}

// Origen canónico: evita sesiones divididas entre nuled.mx y el dominio de Vercel
// (rotación de refresh token cruzada que provoca logout inesperado).
if (typeof window !== 'undefined' && window.location.hostname === 'nuled-os.vercel.app') {
  window.location.replace('https://nuled.mx' + window.location.pathname + window.location.search + window.location.hash);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <CustomerProvider>
          <CurrencyProvider>
            <ProjectListProvider>
              <App />
              <ProjectListPanel />
              <AsesorAIChat />
              <WhatsAppFloat />
              <CookieBanner />
            </ProjectListProvider>
          </CurrencyProvider>
        </CustomerProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
